/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pcr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Edit any per-reaction volume in the table to match your protocol; the totals update automatically.`)
};

const es_pcr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Edita cualquier volumen por reacción en la tabla según tu protocolo; los totales se actualizan automáticamente.`)
};

const de_pcr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Bearbeiten Sie jedes Volumen pro Reaktion in der Tabelle passend zu Ihrem Protokoll; die Gesamtwerte aktualisieren sich automatisch.`)
};

const nl_pcr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Wijzig elk volume per reactie in de tabel om aan uw protocol te voldoen; de totalen worden automatisch bijgewerkt.`)
};

const fr_pcr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Modifiez n'importe quel volume par réaction dans le tableau pour correspondre à votre protocole ; les totaux se mettent à jour automatiquement.`)
};

const it_pcr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Modifica qualsiasi volume per reazione nella tabella per adattarlo al tuo protocollo; i totali si aggiornano automaticamente.`)
};

const pt_br2_pcr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Edite qualquer volume por reação na tabela para corresponder ao seu protocolo; os totais são atualizados automaticamente.`)
};

const pt_pcr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Edite qualquer volume por reação na tabela para corresponder ao seu protocolo; os totais atualizam-se automaticamente.`)
};

const ja_pcr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。表の1反応あたりの量を編集してプロトコルに合わせられます。合計は自動的に更新されます。`)
};

const zh_pcr_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。在表格中编辑任意每反应用量以匹配你的方案，总量会自动更新。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pcr_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pcr_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pcr_faq_a4", locale)
	if (locale === "en") return en_pcr_faq_a4(inputs)
	if (locale === "es") return es_pcr_faq_a4(inputs)
	if (locale === "de") return de_pcr_faq_a4(inputs)
	if (locale === "nl") return nl_pcr_faq_a4(inputs)
	if (locale === "fr") return fr_pcr_faq_a4(inputs)
	if (locale === "it") return it_pcr_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_pcr_faq_a4(inputs)
	if (locale === "pt") return pt_pcr_faq_a4(inputs)
	if (locale === "ja") return ja_pcr_faq_a4(inputs)
	return zh_pcr_faq_a4(inputs)
};